import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Button,
    Container,
    Dimmer,
    Header,
    Icon,
    Label,
    Loader,
    Modal,
    Segment
} from "semantic-ui-react";
import { getTranslate } from "react-localize-redux";
import api from "./api";
// Import React Table
import ReactTable from "react-table";
import "react-table/react-table.css";
import { loadSuppliers, loadWarehouses } from "../../reducer/actions";
import { getSuppliers, getWarehouses } from "../../reducer";
import { push } from "react-router-redux";
import { hasPermission } from "../../../../reducer";
import DetailTab from "./components/DetailTab";
import OrderPanels from "./components/OrderPanels";
import PriceUpdateForm from "./components/PriceUpdateForm";
import Papa from "papaparse";

export const PROCUREMENT_WAREHOUSE_ID = 14;

const inlineStyle = {
    modal: {
        marginTop: "0px !important",
        marginLeft: "auto",
        marginRight: "auto"
    }
};


class Procurement extends Component {

    constructor(props) {
        super(props);
        this.state = {
            products: {},
            orders: {},
            targets: {},
            supplierPrices: {},
            loading: true
        };
    }

    columns = [
        {
            Header: "Code",
            accessor: "code",
            id: "code",
        },
        {
            Header: "Name",
            accessor: "name",
            id: "name",
            minWidth: 250
        }, {
            Header: "Sold (3m)",
            accessor: d => d.soldAdjusted,
            id: "sold",
        }, {
            Header: "Sold Year (scaled to 3m)",
            accessor: d => Math.ceil(d.soldCurrentYearAdjusted / 4),
            id: "soldYear",
        }, {
            Header: "Stock",
            accessor: d => d.inStockByWarehouse[PROCUREMENT_WAREHOUSE_ID],
            id: "stock",
        }, {
            Header: "Stock Adjusted",
            accessor: d => {

                let targets = this.props.warehouses.map((warehouse) => {

                    if (Number.parseInt(warehouse.id, 10) === PROCUREMENT_WAREHOUSE_ID || typeof d.inStockByWarehouse[warehouse.id] === "undefined") {
                        return 0;
                    }

                    if (this.state.targets && this.state.targets[d.id] && this.state.targets[d.id][warehouse.id]) {
                        return d.inStockByWarehouse[warehouse.id] - this.state.targets[d.id][warehouse.id];
                    }


                    return d.inStockByWarehouse[warehouse.id] - Math.ceil(d.soldByWarehouseAdjusted[warehouse.id] / 3);


                });


                return d.inStockByWarehouse[PROCUREMENT_WAREHOUSE_ID] + targets.reduce((a, b) => {
                    return a + b;
                }, 0);
            },
            id: "stockadjusted",
        }, {
            Header: "Reorder Level",
            accessor: "reorderLevel",
            id: "reorderLevel",
        },
        {
            Header: "Order Amount",
            accessor: d => {

                let targets = this.props.warehouses.map((warehouse) => {

                    if (Number.parseInt(warehouse.id, 10) === PROCUREMENT_WAREHOUSE_ID || typeof d.inStockByWarehouse[warehouse.id] === "undefined") {
                        return 0;
                    }

                    if (this.state.targets && this.state.targets[d.id] && typeof this.state.targets[d.id][warehouse.id] !== "undefined") {
                        return d.inStockByWarehouse[warehouse.id] - this.state.targets[d.id][warehouse.id];
                    }


                    return d.inStockByWarehouse[warehouse.id] - Math.ceil(d.soldByWarehouseAdjusted[warehouse.id] / 3);


                });


                return Math.max(d.reorderLevel - d.onOrder - (d.inStockByWarehouse[PROCUREMENT_WAREHOUSE_ID] + targets.reduce((a, b) => {
                    return a + b;
                }, 0)), 0);

            },
            id: "orderAmount"
        },
        {
            Header: "On Order",
            accessor: "onOrder",
            id: "onOrder",
        }
    ];


    prepareProducts(products) {
        return products.reduce((a, b) => {
            a[b.id] = b;
            return a;
        }, {});
    }

    componentDidMount() {
        if (!this.props.hasPermission) {
            return this.props.redirectNoPermission();
        }

        Promise.all([
            this.props.loadSuppliers(),
            this.props.loadWarehouses(),
            this.reloadRequests(),
            this.reloadTargets(),
            this.reloadSupplierPrices()
        ])
            .then((values) => {
                this.setState({
                    products: this.prepareProducts(values[2]),
                    loading: false,
                    targets: values[3],
                    supplierPrices: values[4]

                });
            });
    }

    reloadRequests() {
        return new Promise((resolve) => {
            api.loadRequests()
                .then((products) => {
                    products = !Array.isArray(products) ? products : products.sort((a, b) => {
                        if ((a.inStockByWarehouse[PROCUREMENT_WAREHOUSE_ID] - a.reorderLevel) < (b.inStockByWarehouse[PROCUREMENT_WAREHOUSE_ID] - b.reorderLevel)) {
                            return -1;
                        }
                        return 1;
                    });
                    resolve(products);
                });
        });

    }

    reloadTargets(setState = false) {
        return new Promise((resolve) => {
            api.loadTargets()
                .then((targets) => {
                    targets = this.groupBy(targets, "product_id");
                    let groupedTargets = {};
                    Object.keys(targets)
                        .map((product_id) => {
                            groupedTargets[product_id] = targets[product_id].reduce((a, b) => {
                                a[b.warehouse_id] = b.level;
                                return a;
                            }, {});
                            return targets;
                        });
                    if (setState) {
                        this.setState({ targets: groupedTargets });
                    }
                    resolve(groupedTargets);
                });
        });
    }

    reloadSupplierPrices(setState = false) {
        return new Promise((resolve) => {
            api.loadSupplierPrices()
                .then((prices) => {
                    prices = this.groupBy(prices, "product_id");
                    let groupedPrices = {};
                    Object.keys(prices)
                        .map((product_id) => {
                            groupedPrices[product_id] = prices[product_id].reduce((a, b) => {
                                if(typeof a[b.supplier_id] === 'undefined'){
                                    a[b.supplier_id] = []
                                }
                                a[b.supplier_id].push(b);
                                return a;
                            }, {});

                            return product_id;
                        });
                    if (setState) {
                        this.setState({ supplierPrices: groupedPrices });
                    }
                    resolve(groupedPrices);
                });
        });
    }



    removeProductFromOrder(id) {

        this.setState(({ orders }) => {
            return {
                orders: Object.keys(orders)
                    .filter(key => Number.parseInt(orders[key].id, 10) !== Number.parseInt(id, 10))
                    .reduce((obj, key) => {
                        obj[key] = orders[key];
                        return obj;
                    }, {})

            };
        });
    }


    render() {


        return <div>
            <Dimmer active={this.state.loading}>
                <Loader size='large'>Loading</Loader>
            </Dimmer>
            <Header as='h2' icon textAlign='center'>
                <Icon name='columns' circular/>
            </Header>
            <Header as='h2' color='teal' textAlign='center'>
                {"Procurement"}
            </Header>

            <Container>

                <Modal style={inlineStyle.modal}
                       trigger={<Button fluid primary>Price Changes</Button>}>
                    <Modal.Header>Preisanpassungen</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            <PriceUpdateForm
                                suppliers={this.props.suppliers}
                            />
                        </Modal.Description>
                    </Modal.Content>
                </Modal>
                <Button fluid primary onClick={() => {
                    let csv = Papa.unparse(Object.values(this.state.products));
                    let hiddenElement = document.createElement("a");
                    hiddenElement.href = "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csv);
                    hiddenElement.target = "_blank";
                    hiddenElement.download = "products.csv";
                    hiddenElement.click();
                }}>Download Products</Button>

                {Object.keys(this.state.products).length > 0 &&

                <div>

                    {Object.keys(this.state.orders).length > 0 &&
                    <OrderPanels orders={this.state.orders} suppliers={this.props.suppliers}
                                 removeProductOnOrder={(id) => {
                                     this.removeProductFromOrder(id);
                                 }}/>
                    }

                    <Segment>
                        <Label attached='top'>Produkte</Label>
                        <ReactTable
                            collapseOnDataChange={false}
                            getTrProps={(state, rowInfo) => {
                                if (!rowInfo) {
                                    return {};
                                }
                                const belowLevel = rowInfo ? Number.parseInt(rowInfo.row.stockadjusted, 10) + rowInfo.row.onOrder <= Number.parseInt(rowInfo.row.reorderLevel, 10) : true;
                                const stock = rowInfo ? Number.parseFloat(rowInfo.row.stockadjusted, 10) : 0;
                                let warningThreshold = rowInfo ? Number.parseFloat(rowInfo.row.reorderLevel, 10) / 2 * 3 : 1;

                                const color = this.state.orders[rowInfo.original.id] ? "white" : belowLevel ? "red" : (stock + rowInfo.row.onOrder) <= warningThreshold ? "orange" : "green";


                                return {
                                    style: {
                                        background: color
                                    }
                                };
                            }}
                            filterable
                            defaultFilterMethod={(filter, row) =>
                                String(row[filter.id])
                                    .toLowerCase()
                                    .includes(filter.value.toLowerCase())}
                            data={Object.values(this.state.products)}
                            columns={this.columns}
                            defaultPageSize={30}
                            className="-striped -highlight"
                            defaultSorted={[
                                {
                                    id: "orderAmount",
                                    desc: true
                                }
                            ]}
                            SubComponent={(row, index) => {
                                console.log(row);
                                return (
                                    <DetailTab
                                        product={row.original}
                                        orderAmount={row.row.orderAmount}
                                        warehouses={this.props.warehouses}
                                        targets={this.state.targets}
                                        supplierPrices={this.state.supplierPrices}
                                        onTargetChange={(product_id, warehouse_id, target) => {
                                            api.setTarget(product_id, warehouse_id, target)
                                                .then(() => {
                                                    this.reloadTargets(true);
                                                });
                                        }}
                                        orders={this.state.orders}
                                        suppliers={this.props.suppliers}
                                        onRefreshPrices={() => {
                                            this.reloadSupplierPrices(true);
                                        }}
                                        removeProductOnOrder={(id) => {
                                            this.removeProductFromOrder(id);
                                        }}
                                        setProductOnOrder={(id, order) => {
                                            this.setState((state) => {
                                                state.orders[id] = order;
                                                return state;
                                            });
                                        }}
                                    />
                                );
                            }}
                        />
                    </Segment>
                </div>
                }
            </Container>

        </div>;


    }

    groupBy(xs, key) {
        return xs.reduce(function (rv, x) {
            (rv[x[key]] = rv[x[key]] || []).push(x);
            return rv;
        }, {});
    };


}


const mapStateToProps = state => ({
    translate: getTranslate(state.localize),
    warehouses: getWarehouses(state.tools),
    suppliers: getSuppliers(state.tools),
    hasPermission: hasPermission(state, "procurement")
});


const mapDispatchToProps = (dispatch) => {
    return ({
        loadWarehouses: () => (dispatch(loadWarehouses())),
        loadSuppliers: () => (dispatch(loadSuppliers())),
        redirectNoPermission: () => (dispatch(push("/")))
    });
};


export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Procurement);



// WEBPACK FOOTER //
// ./src/scenes/Tools/scenes/Procurement/index.js